/**
 * @file
 * Dark theme switcher.
 *
 */
((Drupal) => {

  function switchTheme(e) {
    if (e.target.checked) {
      document.documentElement.setAttribute("data-bs-theme", "light");
      localStorage.setItem("theme", "light");
    } else {
      document.documentElement.setAttribute("data-bs-theme", "dark");
      localStorage.setItem("theme", "dark");
    }
  }

  const currentTheme = localStorage.getItem("theme");
  if (currentTheme) {
    document.documentElement.setAttribute("data-bs-theme", currentTheme);
  }

  /**
   * Initialize the switcher JS.
   */
  Drupal.behaviors.darkModeSwitcher = {
    attach(context) {
      once('dark-mode-switcher', '.switch input[type="checkbox"]', context).forEach(function (el) {
        if (currentTheme === "dark") {
          el.checked = false;
        }
        else {
          el.checked = true;
        }

        el.addEventListener("change", switchTheme, false);
      });
    },
  };

}) (Drupal);